<template>
  <div class="calendario-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Calendario Académico</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Consulta tus próximas fechas y eventos</p>
              </div>
            </div>
            <div class="d-flex align-center">
              <v-switch
                v-model="switchLegacyVersion"
                label="Versión anterior"
                @change="goToLegacyVersion"
                hide-details
                class="mt-0 mr-4 switch-premium"
                color="primary"
              ></v-switch>
              <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-calendar-check-outline</v-icon>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <v-row>
              <!-- Center Column: Calendar & Events -->
              <v-col cols="12" md="8" lg="6" class="mx-auto d-flex flex-column gap-4">
                
                <!-- Calendar -->
                <v-card class="rounded-xl border-light bg-white overflow-hidden shadow-premium" elevation="0">
                  <div class="bg-light-gradient pa-3 d-flex align-center justify-space-between border-bottom">
                    <v-btn icon small @click="mesAnterior" color="primary">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <span class="text-subtitle-1 font-weight-bold primary-text text-capitalize d-flex align-center">
                      <v-icon color="primary" class="mr-2">mdi-calendar-month</v-icon>
                      {{ nombreMes }} {{ anioActual }}
                    </span>
                    <v-btn icon small @click="mesSiguiente" color="primary">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                  
                  <div class="pa-4">
                    <table class="premium-calendar w-100">
                      <thead>
                        <tr>
                          <th v-for="dia in diasSemana" :key="dia" class="text-caption font-weight-bold grey--text text-center pb-3">
                            {{ dia }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(semana, sIndex) in semanasDelMes" :key="'sem-'+sIndex">
                          <td v-for="(dia, dIndex) in semana" :key="'dia-'+dIndex" class="text-center pa-1">
                            <v-tooltip bottom v-if="dia && tieneEvento(dia)" color="primary darken-2">
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="calendar-day has-event font-weight-bold" :class="{'is-today': esHoy(dia)}">
                                  {{ dia }}
                                </div>
                              </template>
                              <div v-for="(ev, i) in getEventosDia(dia)" :key="i" class="text-caption mb-1">
                                <strong>{{ ev.titulo }}</strong><br />
                                {{ formatFecha(ev.inicio) }} - {{ formatFecha(ev.fin) }}
                              </div>
                            </v-tooltip>
                            <div v-else-if="dia" class="calendar-day" :class="{'is-today': esHoy(dia), 'is-sunday': esDomingo(sIndex, dIndex)}">
                              {{ dia }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-card>

                <!-- Próximos Eventos -->
                <h2 class="text-h6 font-weight-bold primary-text mt-4 mb-1 d-flex align-center">
                  <v-icon color="primary" class="mr-2">mdi-calendar-star</v-icon> Próximos Eventos
                </h2>
                
                <v-alert prominent type="info" color="primary lighten-5" class="primary--text rounded-xl" v-if="eventos.length == 0 && show == true" elevation="0">
                  <v-icon color="primary" left>mdi-information</v-icon> No hay próximos eventos registrados.
                </v-alert>

                <div class="d-flex flex-column gap-3" v-else>
                  <v-card v-for="(item, index) in eventos" :key="'evt-'+index" class="rounded-xl border-light hover-card bg-white event-card overflow-hidden" elevation="0" :style="'border-left-color: ' + (item.color || '#1976D2') + ' !important'">
                    <div class="pa-4">
                      <div class="d-flex align-center justify-space-between mb-1">
                        <div class="d-flex align-center">
                          <v-icon small color="grey" class="mr-1">mdi-calendar-clock</v-icon>
                          <span class="text-caption font-weight-bold grey--text text-uppercase">{{ item.fecha_inicio }}</span>
                        </div>
                      </div>
                      <h3 class="text-subtitle-1 font-weight-bold primary-text mb-2 line-height-1">{{ item.titulo }}</h3>
                      <p class="text-body-2 grey--text mb-3" v-if="item.notas">{{ item.notas }}</p>
                      
                      <v-btn v-if="item.meet" :href="item.meet" target="_blank" rounded small outlined color="primary" class="text-none custom-btn-shadow font-weight-bold">
                        <v-icon small left>mdi-video-outline</v-icon> Ingresar al enlace
                      </v-btn>
                    </div>
                  </v-card>
                </div>

              </v-col>
            </v-row>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: "CalendarioAcademico",
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            show: false,
            eventos: [],
            mesActual: new Date().getMonth(),
            anioActual: new Date().getFullYear(),
            diasSemana: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            switchLegacyVersion: true
        };
    },
    computed: {
        nombreMes() {
            const meses = [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
            ];
            return meses[this.mesActual];
        },
        semanasDelMes() {
            const primerDia = new Date(this.anioActual, this.mesActual, 1);
            const ultimoDia = new Date(this.anioActual, this.mesActual + 1, 0);
            const diasEnMes = ultimoDia.getDate();
            const diaInicio = primerDia.getDay();

            const semanas = [];
            let semanaActual = new Array(7).fill(null);

            for (let dia = 1; dia <= diasEnMes; dia++) {
                const posicion = (diaInicio + dia - 1) % 7;
                if (posicion === 0 && dia > 1) {
                    semanas.push(semanaActual);
                    semanaActual = new Array(7).fill(null);
                }
                semanaActual[posicion] = dia;
            }
            semanas.push(semanaActual);
            return semanas;
        },
        eventosCalendario() {
            return (Array.isArray(this.eventos) ? this.eventos : [])
                .map((ev, idx) => {
                    const inicioRaw = ev?.inicio || ev?.fecha_inicio || ev?.start || null;
                    const finRaw = ev?.fin || ev?.fecha_fin || ev?.fecha_final || ev?.end || inicioRaw;
                    if (!inicioRaw || !finRaw) return null;

                    return {
                        id: ev?.evento_id || ev?.id || `evento-${idx}`,
                        titulo: ev?.titulo || ev?.title || "Evento",
                        inicio: String(inicioRaw).split(" ")[0],
                        fin: String(finRaw).split(" ")[0],
                        color: ev?.color || "#8E24AA"
                    };
                })
                .filter(Boolean);
        }
    },
    methods: {
        goToLegacyVersion() {
            this.$router.push({ name: "CalendarioAcademicoNew" });
        },
        esHoy(dia) {
            const hoy = new Date();
            return (
                dia === hoy.getDate() &&
                this.mesActual === hoy.getMonth() &&
                this.anioActual === hoy.getFullYear()
            );
        },
        esDomingo(semanaIndex, diaIndex) {
            return diaIndex === 0;
        },
        tieneEvento(dia) {
            return this.eventosCalendario.some((e) => {
                const inicio = new Date(e.inicio);
                const fin = new Date(e.fin);
                const fecha = new Date(this.anioActual, this.mesActual, dia);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(0, 0, 0, 0);
                fecha.setHours(0, 0, 0, 0);
                return fecha >= inicio && fecha <= fin;
            });
        },
        getEventosDia(dia) {
            return this.eventosCalendario.filter((e) => {
                const inicio = new Date(e.inicio);
                const fin = new Date(e.fin);
                const fecha = new Date(this.anioActual, this.mesActual, dia);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(0, 0, 0, 0);
                fecha.setHours(0, 0, 0, 0);
                return fecha >= inicio && fecha <= fin;
            });
        },
        formatFecha(fechaStr) {
            if (!fechaStr) return "";
            return String(fechaStr).split(" ")[0].split("-").reverse().join("/");
        },
        mesAnterior() {
            if (this.mesActual === 0) {
                this.mesActual = 11;
                this.anioActual--;
            } else {
                this.mesActual--;
            }
        },
        mesSiguiente() {
            if (this.mesActual === 11) {
                this.mesActual = 0;
                this.anioActual++;
            } else {
                this.mesActual++;
            }
        },
        async obtenerProximosEventos() {
            const url = `calendario/proximos-eventos?tipo_usuario=${this.$store.getters.user.tipoUsuario}&plataforma=IEA`;

            this.$API
                .get({
                    url
                })
                .then((res) => {
                    this.eventos = Array.isArray(res?.eventos) ? res.eventos : [];
                    this.show = true;
                })
                .catch(() => {
                    this.eventos = [];
                    this.show = true;
                });
        }
    },
    mounted() {
        this.obtenerProximosEventos();
    }
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.calendario-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important; }

.hover-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important;
}

.shadow-premium {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,0.08) !important;
}

.custom-btn-shadow {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
  transition: all 0.3s ease;
}
.custom-btn-shadow:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px -6px rgba(25, 118, 210, 0.5) !important;
}

.gap-3 { gap: 12px; }
.gap-4 { gap: 20px; }

.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }

/* Premium Calendar */
.premium-calendar {
  border-collapse: collapse;
}
.calendar-day {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 14px;
  color: #475569;
  transition: all 0.2s ease;
}
.calendar-day.is-sunday {
  color: #ef4444;
  font-weight: 500;
}
.calendar-day.is-today {
  background-color: #1976D2;
  color: white;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3);
}
.calendar-day.has-event {
  background-color: rgba(25, 118, 210, 0.1);
  color: #1976D2;
  border: 1px solid rgba(25, 118, 210, 0.2);
  cursor: pointer;
}
.calendar-day.has-event:hover {
  background-color: rgba(25, 118, 210, 0.2);
}

.event-card {
  border-left-style: solid !important;
  border-left-width: 4px !important;
}
</style>
